export const API = "https://edirne-karabuk-onboard.onrender.com/karabuk";
// export const API = "https://tmskarabuklokomotif.herokuapp.com";